import { render, staticRenderFns } from "./GetStartedNavNextButton.vue?vue&type=template&id=5e58a8a0&scoped=true&"
import script from "./GetStartedNavNextButton.vue?vue&type=script&lang=ts&"
export * from "./GetStartedNavNextButton.vue?vue&type=script&lang=ts&"
import style0 from "./GetStartedNavNextButton.vue?vue&type=style&index=0&id=5e58a8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58a8a0",
  null
  
)

export default component.exports